import { render, staticRenderFns } from "./BaseForm.vue?vue&type=template&id=ef89bfae&"
import script from "./BaseForm.js?vue&type=script&lang=js&"
export * from "./BaseForm.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports